// automatically generated by the FlatBuffers compiler, do not modify

export enum ElevatorGroupControl {
  SEC = 0,
  ARS = 1
}
